



















































































import _ from 'lodash';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { ScreenSize } from '@/main/components/constants';

import { EmailEdit, SmsEdit, SmsTextType } from './state';
import { apiProvider as apiProviderForEdit } from './api';
import { EMAIL_TYP_PZN, MESSAGE_TYPE, SMS_TYP_PZN } from './constants';

export default PageModeMixin.extend({
	name: 'SmsEmailModal',
	props: {
		msgType: {
			type: String,
			default: MESSAGE_TYPE.SMS_EMAIL,
			validator: (item) => (Object.values(MESSAGE_TYPE) as string[]).includes(item),
		},
		zakaznikId: { type: Number, default: null },
		vozidloId: { type: Number, default: null },
		zakazkaId: { type: Number, default: null },
		dokladId: { type: Number, default: null },
		emailTypPzn: { type: Number, default: null },
		smsTypPzn: { type: Number, default: null },
		visible: { type: Boolean },
		smsDisabled: { type: Boolean, default: false },
		emailDisabled: { type: Boolean, default: false },
		pdf: { type: [Object, Array], default: null },
	},
	data() {
		return {
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			fileList: [] as any[],
			emailState: new EmailEdit(false),
			smsState: new SmsEdit(false),
			loading: false,
			error: false,
			MESSAGE_TYPE,
		};
	},
	computed: {
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
		spanSize(): number {
			return this.msgType !== MESSAGE_TYPE.SMS_EMAIL ? 24 : 12;
		},
		isHromadnaSms() {
			return this.smsTypPzn === SMS_TYP_PZN.DEZEN_PNEU && this.msgType === MESSAGE_TYPE.SMS;
		},
		smsPovinnyText(): string {
			return this.selectedSmsTxt?.PovinnyText || '';
		},
		smsVolitelnyText(): string {
			return this.selectedSmsTxt?.VolitelnyText || '';
		},
		selectedSmsTxt(): SmsTextType | null {
			return this.smsTextFiltered.find((item) => item.Value === this.smsState.TemplatePzn) || null;
		},
		smsTextFiltered(): SmsTextType[] {
			return this.smsState.DropDownList?.SmsText.filter((item : any) => item.SmsTypPzn === this.smsState.SmsTypPzn);
		},
		isEmailVisible(): boolean {
			return this.msgType === MESSAGE_TYPE.EMAIL || this.msgType === MESSAGE_TYPE.SMS_EMAIL;
		},
		isSmsVisible(): boolean {
			return this.msgType === MESSAGE_TYPE.SMS || this.msgType === MESSAGE_TYPE.SMS_EMAIL;
		},
		visibleCmp: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			},
		},
		modalLabel(): string {
			return this.LocalizeFormular('edtSmsEmail');
		},
		emailRecepientList(): Record<string, any>[] {
			return _.map(this.emailState.RecepientList || [], (item) => ({ value: item }));
		},
		emailTemplateList(): Record<string, any>[] {
			return this.formatTemplateList(this.emailState.MsgLogEmailTemplateList);
		},
		smsRecepientList(): Record<string, any>[] {
			return _.map(this.smsState.RecepientList || [], (item) => ({ Text: item, Value: item }));
		},
		disableOk(): boolean {
			return this.error || (!this.smsState.checked && !this.emailState.checked);
		},
		validationRules(): { emailState: Record<string, any>; smsState: Record<string, any> } {
			return {
				emailState: this.emailState.checked ? this.emailState.ValidationRules! : {},
				smsState: this.smsState.checked ? this.smsState.ValidationRules! : {},
			};
		},
		validator(): Function {
			return (this.$children[0].$refs.modalForm as any).validate;
		},
	},
	watch: {
		visible(newVisible) {
			if (newVisible) {
				this.smsState.checked = !this.smsDisabled;
				this.fetchTemplates();
			} else {
				this.emailState = new EmailEdit(false);
				this.smsState = new SmsEdit(false);
				this.error = false;
				this.loading = false;
				this.fileList = [];
			}
		},
		'emailState.emailTypPzn': {
			handler() {
				this.emailState.TemplatePzn = this.emailTemplateList.length === 1 ? this.emailTemplateList[0].Value : null;
			},
		},
		'emailState.TemplatePzn': {
			handler(index) {
				const { Subj, Osloveni, Pozdrav, Msg } = this.emailState.MsgLogEmailTemplateList![index] || {};
				this.emailState.Subj = Subj;
				this.emailState.Osloveni = Osloveni;
				this.emailState.Pozdrav = Pozdrav;
				this.emailState.Msg = Msg;
			},
		},
		'smsState.smsTypPzn': {
			handler() {
				this.smsState.PovinnyText = null;
				this.smsState.VolitelnyText = null;
				this.smsState.TemplatePzn = this.smsTextFiltered.length > 0 ? this.smsTextFiltered[0].Value : null;
			},
		},
		selectedSmsTxt() {
			const { PovinnyText, VolitelnyText } = this.selectedSmsTxt || {};
			this.smsState.PovinnyText = PovinnyText || '';
			this.smsState.VolitelnyText = VolitelnyText || '';
		},
		pdf() {
			this.fileList = [];
			if (!_.isNil(this.pdf) && !Array.isArray(this.pdf)) {
				this.fileList.push({
					name: 'DmsTemporary.pdf',
					raw: this.pdf.pdfBlob,
				});
			} else {
				this.pdf!.forEach((element: any) => {
					this.fileList.push({
						name: `${element.name}.pdf`,
						raw: element.pdf.pdfBlob,
					});
				});
			}
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		formatTemplateList(msgLogList: Record<string, any>[] | null = []) {
			const mapped = _.map(msgLogList, ({ Poznamka }, index) => ({ Text: Poznamka || ' ', Value: index, Poznamka }));
			return mapped.length > 1 ? _.filter(mapped, (item) => !!item.Poznamka) : mapped;
		},
		async fetchSmsTemplate() {
			if (!this.smsState.checked) return;

			const { zakaznikId, vozidloId, zakazkaId, dokladId, smsTypPzn } = this;
			const apiParams = _.omitBy({ smsTypPzn, zakazkaId, vozidloId, dokladId, zakaznikId }, _.isNil);
			try {
				const { data: smsTemplateData } = await apiProviderForEdit.fetchSmsTemplate(apiParams);
				this.smsState = { ...this.smsState, ...smsTemplateData, smsTypPzn };
				if (this.smsState!.RecepientList?.length === 1) {
					[this.smsState!.Recepient] = this.smsState.RecepientList!;
				}
			} catch (err) {
				console.log(err);
				this.error = true;
			} finally {
				this.loading = false;
			}
		},
		async fetchEmailTemplate() {
			if (!this.emailState.checked) return;

			const { zakaznikId, vozidloId, zakazkaId, dokladId, emailTypPzn } = this;
			const apiParams = _.omitBy(
				{
					emailTypPzn,
					zakazkaId,
					vozidloId,
					dokladId,
					zakaznikId: emailTypPzn === EMAIL_TYP_PZN.ZAKAZNIK ? zakaznikId : null,
				},
				_.isNil,
			);
			try {
				const { data: emailTemplateData } = await apiProviderForEdit.fetchEmailTemplate(apiParams);
				if (emailTemplateData.PreparedAttachments) {
					this.fileList = emailTemplateData.PreparedAttachments.map((attachment: Record<string, any>) => {
						attachment.name = attachment.Name;
						attachment.prepared = true;
						return attachment;
					});
				}
				this.emailState = { ...this.emailState, ...emailTemplateData, emailTypPzn };
				if (this.emailState!.RecepientList!.length === 1) {
					[this.emailState!.Recepient] = this.emailState.RecepientList!;
				}
			} catch (err) {
				console.log(err);
				this.error = true;
			} finally {
				this.loading = false;
			}
		},
		async fetchTemplates() {
			try {
				this.loading = true;
				await Promise.all([this.fetchEmailTemplate(), this.fetchSmsTemplate()]);
			} catch (err) {
				this.error = true;
			} finally {
				this.loading = false;
			}
		},
		setDefaultData() {
			if (this.emailState!.RecepientList!.length === 1) {
				[this.emailState!.Recepient] = this.emailState.RecepientList!;
			}
			if (this.smsState!.RecepientList!.length === 1) {
				[this.smsState!.Recepient] = this.smsState.RecepientList!;
			}
		},
		async sendData() {
			const isValid = await this.validate();
			if (!isValid) {
				return;
			}

			const generalData = { ZakaznikId: this.zakaznikId, VozidloId: this.vozidloId, ZakazkaId: this.zakazkaId, DokladId: this.dokladId };
			const msgLogEmail = { ...this.emailState, ...generalData };
			const smsFormData = { ...this.smsState, ...generalData };
			if (this.$listeners.send) {
				this.$emit('send', { generalData, msgLogEmail, smsFormData });
				return;
			}

			const emailFormData = new FormData();

			msgLogEmail.PreparedAttachments = this.fileList.filter((file) => file.prepared);
			const newAttachments = this.fileList.filter((file) => !file.prepared);
			for (let i = 0; i < newAttachments.length; i++) {
				emailFormData.append('attachments', (newAttachments[i] as Record<string, any>).raw, (newAttachments[i] as Record<string, any>).name);
			}
			emailFormData.append('msgLogEmail', JSON.stringify(msgLogEmail));

			try {
				this.loading = true;
				const sendEmail = this.emailState.checked ? apiProviderForEdit.sendEmail(emailFormData) : Promise.resolve({ data: true });
				const sendSms = this.smsState.checked ? apiProviderForEdit.sendSms(smsFormData) : Promise.resolve({ data: true });
				const [emailResponse, smsResponse] = await Promise.all([sendEmail, sendSms]);
				if (emailResponse.data && smsResponse.data) {
					this.visibleCmp = false;
				} else {
					const message = this.LocalizeChyboveHlasky('EmailSMSNotSent');
					console.error(message);
					this.showErrorNotification(message);
				}
			} finally {
				this.$emit('on-send');
				this.visibleCmp = false;
				this.loading = false;
			}
		},
		async validate() {
			let isValid;

			this.validator((valid: boolean) => {
				isValid = valid;

				valid || this.showErrorAlert({ message: 'InvalidForm' });
			});

			return isValid;
		},
		beforeRemove(file: { Mandatory: boolean }) {
			return !file.Mandatory;
		},
		fetchSuggestions(queryString: string, cb: Function) {
			const filterFunc = _.isNil(queryString) ? _.identity : (item: Record<string, any>) => _.startsWith(item.value.toLowerCase(), queryString.toLowerCase());
			return cb(this.emailRecepientList.filter(filterFunc));
		},
	},
});
